var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCheckmark = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "#fff",
  viewBox: "0 0 24 25"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M20.644 6.124a1 1 0 0 1 .12 1.409l-10.108 12a1 1 0 0 1-1.479.056l-5.89-6a1 1 0 0 1 1.427-1.4l5.12 5.215 9.401-11.16a1 1 0 0 1 1.41-.12",
  clipRule: "evenodd"
})));
export default SvgCheckmark;